module.exports = __webpack_public_path__ + "static/media/che8.ab174b55.png";